import * as React from "react"
import { useState, useEffect, createContext } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { HomePageLink } from "@costcolabs/forge-digital-components"
import { SiteEnum } from "../constants/immunizationEnums"
import scanLogo from "../images/scanLogo.png"
import { screenSizeContext } from "../utils/ResponsiveHandler"

import "./header.css"

function Header({ siteTitle, site }) {
  const redirectUrl = process.env.GATSBY_PHARMACY_HOME_URL
  const isScanSite = site === SiteEnum.SCAN
  let scanLogoMarginLeft = "32px"
  if (typeof window !== "undefined" && window.innerWidth <= 900) {
    scanLogoMarginLeft = "24px"
  }

  return (
    <div className="temp_header">
      <header>
        <nav aria-label="Main navigation to go to Costco Home">
          <div
            className="home_logo"
            style={{ display: "flex", alignItems: "center" }}
          >
            <a
              href={redirectUrl}
              aria-label={`${siteTitle} Home`}
              className="logo-link"
            >
              <StaticImage
                alt="Costco Pharmacy logo"
                height={40}
                style={{
                  margin: "50px 0 0 20%",
                  backgroundColor: "#ffffff !important",
                }}
                src="../images/LogoPharmacy.svg"
                placeholder="none"
              />
            </a>
            {isScanSite && (
              <img
                src={scanLogo}
                alt="SCAN Medicare Advantage logo"
                height={40}
                style={{
                  marginLeft: scanLogoMarginLeft,
                  marginTop: "60px",
                  display: "inline-block",
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  padding: "2px 4px",
                }}
              />
            )}
          </div>
        </nav>
      </header>
    </div>
  )
}
export default Header
